import { refresh } from '~/util/yotpo';

function useYotpoRefresh() {
  onMounted(() => refresh());
}

export { useYotpoRefresh };
